export const UserIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="user-icon"
    >
      <path
        d="M4.125 22C4.125 17.5817 7.70672 14 12.125 14C16.5433 14 20.125 17.5817 20.125 22H18.125C18.125 18.6863 15.4387 16 12.125 16C8.81129 16 6.125 18.6863 6.125 22H4.125ZM12.125 13C8.81 13 6.125 10.315 6.125 7C6.125 3.685 8.81 1 12.125 1C15.44 1 18.125 3.685 18.125 7C18.125 10.315 15.44 13 12.125 13ZM12.125 11C14.335 11 16.125 9.21 16.125 7C16.125 4.79 14.335 3 12.125 3C9.915 3 8.125 4.79 8.125 7C8.125 9.21 9.915 11 12.125 11Z"
        fill="#848484"
      />
    </svg>
  );
};
